export enum PAGE {
  HOME = '/',
  START = '/start',
  OTP = '/otp',
  OFFER = '/offer',
  ERROR = '/error',
  ASYNC_APP_TIMEOUT = '/application-timeout',
  ACCEPT = '/accept',
  ACCOUNT_STATUS = '/account-status',
  FIND_ACCOUNT = '/find-user-account',
  CHECK_APPLICATION = '/checkApplication',
  CREDIT = '/:partner/credit',
  CREDIT_PROGRAM = '/:partner/:program/credit',
  CREATE_PIN = '/create-pin',
  COMPLETE_ON_PHONE = '/complete-on-phone',
  ONBOARDING = '/onboarding',
  STORE = '/:partner/store',
}
